// This file defines the application's color palette and font as reusable TypeScript constants.
// Update the color values and font family below to match your official palette and typography from the provided PDF.
export const AppColors = {
    appBackground: '#f2f3f7',
    headerBackground: '#244056',
    sidebarBackground: '#e9f0ee',
    sidebarActive: '#cfd3d1',
    controlBarActive: '#686868',
    controlBarInactive: '#afafaf',
    cardBackground: '#ffffff',
    border: '#d7dbe0',
    searchBorder: '#333333',
    fontPrimary: '#010101',
    fontOnDark: '#ffffff',
    progressInReview: '#ec8c23',
    progressComplete: '#079b49',
    progressDraft: '#ffce04',
    progressRejected: '#d92e27',
    typeLaborBackground: '#0076a8',
    errorBackground: '#fff8f8',
    fontDarkGray: '#333333',
    periodLabel: '#9aa3a8',
};
export const StatusBadgePalette = {
    partial: {
        background: '#fef3c7',
        border: '#d1b86f',
        text: '#92400e',
        icon: '#f59e0b',
    },
    draft: {
        background: '#dbeafe',
        border: '#669ad3',
        text: '#1e3a8a',
        icon: '#3b82f6',
    },
    approved: {
        background: '#dcfce7',
        border: '#77ad88',
        text: '#166534',
        icon: '#16a34a',
    },
    error: {
        background: '#fee2e2',
        border: '#7f1d1d',
        text: '#7f1d1d',
        icon: '#b91c1c',
    },
    // Rejected reuses the red error palette — same visual weight, different
    // semantic (review finished, all items rejected vs. review run failed).
    rejected: {
        background: '#fee2e2',
        border: '#7f1d1d',
        text: '#7f1d1d',
        icon: '#b91c1c',
    },
};
// ─────────────────────────────────────────────────────────────────────────────
// Design tokens — Button palette
// Background hexes from the design spec. Text colors derived for AA contrast.
// ─────────────────────────────────────────────────────────────────────────────
export const ButtonPalette = {
    primary: {
        background: '#447e9e',
        text: '#ffffff',
    },
    action: {
        // "Send to Review" / primary positive action
        background: '#16a34a',
        text: '#ffffff',
    },
    secondary: {
        // "Save as Draft" / neutral secondary action
        background: '#ebf4fc',
        border: '#cbd5e1',
        text: '#1e3a8a',
    },
    destructive: {
        // "Discard" / irreversible action
        background: '#dc2626',
        text: '#ffffff',
    },
};
export const AppFont = {
    family: 'Helvetica Neue Arial, sans-serif',
};
// Usage: import { AppColors, AppFont, ButtonPalette, StatusBadgePalette } from './styles/colors';
// Example: style={{ backgroundColor: ButtonPalette.action.background }}
